import { EMAIL_UPDATE } from './reduxConstant';

export const emailUpdate = (email) => {
  return {
    type: EMAIL_UPDATE,
    payload: {
      email,
    },
  };
};
